import React, { useState } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import style from './style.scss';

const CustomizedSelect = ({
  data,
  name = '',
  value = '',
  label = null,
  className = '',
  onChange,
  hasError = false,
  errorMessage = '',
  isRequired = false,
  isBadgeVisible = true,
  isDisabled = false,
  showSelectOption = true,
  ...restProps
}) => {
  const [isVisited, setIsVisited] = useState(false);
  const [isRequiredState, setIsRequiredState] = useState(false);

  const handleBlur = (e) => {
    setIsVisited(true);
    if (e.target.value) {
      setIsRequiredState(false);
    } else {
      setIsRequiredState(isRequired);
    }
  };

  return (
    <label className={cn({ 'has-value': true, required: !isDisabled && ((isVisited && isRequiredState) || hasError), [style.disabled]: isDisabled })}>
      { label &&
      <span>{label} {
          isBadgeVisible && ((isVisited && isRequired) || hasError) && <em>Required</em>
        }
        {
          isVisited && !isRequired && !isDisabled && <em>Optional</em>
        }
        {!isRequired && isDisabled && <em>Disabled</em>}
      </span>
      }
      <select
        name={name}
        onChange={onChange}
        onBlur={handleBlur}
        className={style.select}
        disabled={isDisabled}
        {...restProps}
      >
        {showSelectOption && <option value="">Select...</option>}
        {
          data.map(item => (
            value === item.value ?
              <option key={item.value} value={item.value} selected>{item.title}</option>
            :
              <option key={item.value} value={item.value}>{item.title}</option>
          ))
        }
      </select>
      <div className={style.error}>{errorMessage !== 'The input field is required' && errorMessage}</div>
    </label>
  );
};

CustomizedSelect.propTypes = {
  className: PropTypes.string,
  data: PropTypes.array.isRequired,
  hasError: PropTypes.bool,
  errorMessage: PropTypes.string,
  label: PropTypes.node,
  name: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
  isRequired: PropTypes.bool,
  isBadgeVisible: PropTypes.bool,
  isDisabled: PropTypes.bool,
  showSelectOption: PropTypes.bool,
};

export default CustomizedSelect;
